import React from 'react'
import {PageTitle} from '../../Molecules/BaseMembersPages/PageTitle'
import {ContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {ContentTitle} from '../../Molecules/BaseContentBlocks/ContentTitle'
import {ContentTopMessage} from '../../Molecules/BaseContentBlocks/ContentTopMessage'

function MembersInvalidOperationPage(): JSX.Element {
  return (
    <>
      <PageTitle>ご案内</PageTitle>
      <ContentBlock>
        <ContentTitle>不正な操作が行われました</ContentTitle>
        <ContentTopMessage>最初からやり直してください。</ContentTopMessage>
      </ContentBlock>
    </>
  )
}

export default MembersInvalidOperationPage
